import { v4 as uuid } from 'uuid';
import { isUUID } from './uuid-utils';

const formUtils = {
    isNewFormId(idString) {
        return isUUID(idString.toString());
    },
    isValidId(idString) {
        return formUtils.isNewFormId(idString) || Number.isInteger(Number(idString));
    },
    createNewIdentifier() {
        return uuid().toString();
    }
}

export default formUtils;